import styled from "styled-components"

import { Typography } from "components/common/index"

const SectionText = styled(Typography)`
  ${({ theme }) => `
    font-size: ${theme.fontSizes[16]};
    margin-bottom: ${theme.space[2]};
  `}
`

export default SectionText
